import { render, staticRenderFns } from "./TableProblemasDiagnostico.vue?vue&type=template&id=3aa0d35a"
import script from "./TableProblemasDiagnostico.vue?vue&type=script&lang=js"
export * from "./TableProblemasDiagnostico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports